import 'ion-rangeslider';
import config from './config';

const { backendApiUrl } = config();

const pricing = async () => {
	// Check if its pricing page, then only proceed.
	const currentUrl = window.location.href;

	if (-1 === currentUrl.indexOf('web-push-notifications-shopify-pricing')) {
		return;
	}

	let growthPlan,
		growthDefaultPlan = {};
	const growthPlanSubscriberCount = [];

	const pricingCurrentStatus = {
		period: 'year',
		planName: 'growth'
	};

	async function getPlanDetails() {
		let result;
		const serverUrl = `${backendApiUrl}/d/v1/misc/payment/plans?platform=shopify`;

		try {
			result = await jQuery.ajax({
				url: serverUrl,
				type: 'GET'
			});
			return result;
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	}

	async function createSliders() {
		let firstMonthlyGrowthPlan = {},
			firstYearlyGrowthPlan = {},
			highestDiscountPercentage = 0;

		const planDetails = await getPlanDetails();

		planDetails.data.forEach(function (plans) {
			if ('growth' === plans.plan_type) {
				growthPlan = plans.tiers;
				growthPlan.forEach(function (planTier) {
					if ('month' === planTier.plan_mode) {
						// for month & year the subscriber count will be the same.
						growthPlanSubscriberCount.push(planTier.subscribers_limit);

						if (!firstMonthlyGrowthPlan.subscribers_limit) {
							firstMonthlyGrowthPlan = planTier;
						} else if (planTier.subscribers_limit < firstMonthlyGrowthPlan.subscribers_limit) {
							firstMonthlyGrowthPlan = planTier;
						}
					}

					if ('year' === planTier.plan_mode) {
						if (!firstYearlyGrowthPlan.subscribers_limit) {
							firstYearlyGrowthPlan = planTier;
						} else if (planTier.subscribers_limit < firstYearlyGrowthPlan.subscribers_limit) {
							firstYearlyGrowthPlan = planTier;
						}

						// filter highest discount percentage from each plan
						if (highestDiscountPercentage < (planTier?.first_year_discount || 0)) {
							highestDiscountPercentage = planTier.first_year_discount;
						}
					}
				});

				firstYearlyGrowthPlan.plan = plans;
				firstMonthlyGrowthPlan.plan = plans;
			}
		});

		// Update the discount percentage label
		const pricingDiscountLabelElement = document.getElementById('pricing-discount-percentage-label');
		const pricingDiscountTableLabelElement = document.getElementById('pricing-discount-percentage-table-label');

		if (CORE_SITE_ENV?.price_percentage_label) {
			// Get the discount percentage from the label, \d+ matches one or more digits
			let highestDiscountPercentageFromDB = CORE_SITE_ENV.price_percentage_label.match(/\d+/);
			// Convert the matched string to an integer
			highestDiscountPercentageFromDB = highestDiscountPercentageFromDB
				? parseInt(highestDiscountPercentageFromDB[0], 10)
				: 0;

			if (highestDiscountPercentageFromDB > highestDiscountPercentage) {
				highestDiscountPercentage = highestDiscountPercentageFromDB;
			}
		}

		if (pricingDiscountLabelElement) {
			pricingDiscountLabelElement.innerHTML = `save upto ${highestDiscountPercentage}%`;
		}

		if (pricingDiscountTableLabelElement) {
			pricingDiscountTableLabelElement.innerHTML = `save upto ${highestDiscountPercentage}%`;
		}

		if (Object.keys(firstMonthlyGrowthPlan).length && Object.keys(firstYearlyGrowthPlan).length) {
			const yearlyPrice = Number(firstYearlyGrowthPlan.price / 12);
			growthDefaultPlan = {
				...growthDefaultPlan,
				yearlyPrice: Math.round(yearlyPrice),
				monthlyPrice: Number(firstMonthlyGrowthPlan.price),
				discountedYearlyPrice: Math.round(
					(yearlyPrice * (100 - firstYearlyGrowthPlan.first_year_discount)) / 100
				),
				yearlySaving: Math.round(firstYearlyGrowthPlan.price - firstYearlyGrowthPlan.first_year_price)
			};
		}

		jQuery('#pricing-subscriber-growth-range-slider').ionRangeSlider({
			skin: 'round',
			values: growthPlanSubscriberCount.map((subscriberCount) => `${subscriberCount / 1000}k`),
			prettify_separator: ',',
			grid: true,
			onChange() {
				changePriceOnCalculatorResult();
			}
		});
	}

	// Create the price range slider for price calculator
	await createSliders();

	/* --------  Start handling the year/month toggle --------*/
	jQuery('.pricing-front-growth-price').text(growthDefaultPlan.discountedYearlyPrice);
	jQuery('.pricing-front-growth__reduce-price').text(`$${growthDefaultPlan.yearlyPrice}`);
	jQuery('.pricing-front-growth__saving-price').text(`$${growthDefaultPlan.yearlySaving} savings*`);

	// Making sure yearly plan should be selected after rendering completion of the pricing page.
	jQuery(document).ready(function () {
		pricingCurrentStatus.period = 'year';
		jQuery('#plan-period-table,#plan-period-detail-table').prop('checked', true);
		jQuery(document).on('click', '#pricing-free-plan-btn', function () {
			window.location.href = '/signup/?planName=free';
		});
	});

	jQuery(document).on('change', '#plan-period-table, #plan-period-detail-table', function () {
		changePlanPeriod(this);
	});

	function changePlanPeriod(reference) {
		if (jQuery(reference).is(':checked')) {
			pricingCurrentStatus.period = 'year';
			jQuery('#plan-period-table,#plan-period-detail-table').prop('checked', true);
		} else {
			pricingCurrentStatus.period = 'month';
			jQuery('#plan-period-table,#plan-period-detail-table').prop('checked', false);
		}

		jQuery('.pricing-front-switch-label-text').toggleClass('bolder');
		changePricePlan();
	}

	function changePricePlan() {
		if ('year' === pricingCurrentStatus.period) {
			// actual price
			jQuery('.pricing-front__reduce-text').show();
			jQuery('.pricing-front-growth-price').text(growthDefaultPlan.discountedYearlyPrice);

			// crossed or monthly price actual price
			jQuery('.pricing-front-growth__reduce-price').show();
			jQuery('.pricing-front-growth__reduce-price').text(`$${growthDefaultPlan.yearlyPrice}`);

			// handling saved  price and maintaining space alignments
			jQuery(
				'.pricing-front-growth__saving-price, .pricing-front-calculator__saving-price'
			).show();
			jQuery('.pricing-front-growth__saving-price').text(`$${growthDefaultPlan.yearlySaving} savings*`);
			jQuery(
				'.pricing-front__saving-tag,.pricing-front-growth__saving-text,.pricing-front-calculator__saving-text'
			).css('background', '#FFD37D');
			jQuery('.pricing-front-calculator__saving-text-billed').show();
		} else {
			// actual price
			jQuery('.pricing-front__reduce-text').hide();
			jQuery('.pricing-front-growth-price').text(growthDefaultPlan.monthlyPrice);

			// crossed or monthly price reduced price
			jQuery('.pricing-front-growth__reduce-price').hide();

			// handling saved  price and maintaining space alignments
			// here we are not hiding the parent "p" tags just hiding span inside it
			jQuery('.pricing-front-growth__saving-price,.pricing-front-calculator__saving-price').hide();
			jQuery(
				'.pricing-front__saving-tag, .pricing-front-growth__saving-text, .pricing-front-calculator__saving-text'
			).css('background', 'none');
			jQuery('.pricing-front-calculator__saving-text-billed').hide();
		}

		changePriceOnCalculatorResult();
	}
	/* --------  End handling the year/month toggle --------*/

	/* --------  Start handling enterprise tab --------*/
	jQuery('#pricing-calculator-enterprise-content').css('display', 'none');
	jQuery('#growth-tab').css({ borderBottom: '1px solid #3B43FF', color: '#3B43FF' });


	jQuery('#growth-tab').click(function () {
		pricingCurrentStatus.planName = 'growth';
		changePriceOnCalculatorResult();
		jQuery('#pricing-calculator-growth-content').css('display', 'block');
		jQuery('#pricing-calculator-enterprise-content').css('display', 'none');

		jQuery('#growth-tab').css({ borderBottom: '1px solid #3B43FF', color: '#3B43FF' });
		jQuery('#enterprise-tab').css({ borderBottom: 'unset', color: '#47485D' });

		jQuery('.pricing-front-calculator__action__plan-name').text('Automation');
		jQuery('#pricing-enterprise-content').hide();
		jQuery('#pricing-enterprise-not-content').show();
	});

	jQuery('#enterprise-tab').click(function () {
		pricingCurrentStatus.planName = 'enterprise';
		jQuery('#pricing-calculator-growth-content').css('display', 'none');
		jQuery('#pricing-calculator-enterprise-content').css('display', 'block');

		jQuery('#growth-tab').css({ borderBottom: 'unset', color: '#47485D' });
		jQuery('#enterprise-tab').css({ borderBottom: '1px solid #3B43FF', color: '#3B43FF' });

		jQuery('.pricing-front-calculator__action__plan-name').text('Enterprise');
		jQuery('#pricing-enterprise-not-content').hide();
		jQuery('#pricing-enterprise-content').show();
	});

	/* --------  End handling enterprise tab --------*/

	/* --------  Start handling slider and the price calculator --------*/
	function getSubscriberSliderPrice(period, saving) {
		let planPrice = '',
			savings,
			iter,
			subscribersCount = jQuery('#pricing-subscriber-growth-range-slider').val();

		const selectedPlan = growthPlan

		const planPeriod = period ? period : pricingCurrentStatus.period;

		// convert the subscriber count to number y suffix 'K'
		subscribersCount = Number(subscribersCount.slice(0, -1)) * 1000;

		// find the plan tier matching the plan_mode and subscriber count. For yearly plan calculate the monthly price
		// that will be displayed in the UI.
		for (iter = 0; iter < selectedPlan.length; iter++) {
			const currPlanTier = selectedPlan[iter];
			if (
				'month' === planPeriod &&
				'month' === currPlanTier.plan_mode &&
				subscribersCount === currPlanTier.subscribers_limit
			) {
				planPrice = currPlanTier.price;
				break;
			}

			if (
				'year' === planPeriod &&
				'year' === currPlanTier.plan_mode &&
				subscribersCount === currPlanTier.subscribers_limit
			) {
				planPrice = Math.round(parseInt(currPlanTier.first_year_price, 10) / 12);
				savings = Math.round(currPlanTier.price - currPlanTier.first_year_price);
				break;
			}

			if (
				'month_up' === planPeriod &&
				'year' === currPlanTier.plan_mode &&
				subscribersCount === currPlanTier.subscribers_limit
			) {
				planPrice = Math.round(parseInt(currPlanTier.price, 10) / 12);
				break;
			}
		}

		// this is the 15% saving part in case of yearly plan
		if (saving && 'year' === planPeriod) {
			return savings;
		}

		return planPrice;
	}

	function changePriceOnCalculatorResult() {
		if ('enterprise' !== pricingCurrentStatus.planName) {
			const planPrice = getSubscriberSliderPrice();
			const planPriceMonth =
				'month' === pricingCurrentStatus.period
					? getSubscriberSliderPrice('month')
					: getSubscriberSliderPrice('month_up');

			const planSavingPrice = 'year' === pricingCurrentStatus.period ? getSubscriberSliderPrice('year', true) : 0;

			jQuery('#pricing-calculator-result').text(planPrice);
			jQuery('#pricing-calculator-result-monthly').text('$' + planPriceMonth);
			jQuery('.pricing-front-calculator__saving-price').text('$' + planSavingPrice.toFixed(0) + ' savings*');
			return {
				planPrice,
				planPriceMonth,
				planSavingPrice
			};
		}

		return {};
	}

	/* --------  End handling slider and the price calculator --------*/

	/* --------  Start handling pricing page to signup page redirection part --------*/
	jQuery(document).on('click', '.pricing-front__action--request-demo', function () {
		window.location.href = './schedule';
	});

	jQuery(document).on('click', '.pricing-front__action--trial', function () {
		window.location.href = 'https://apps.shopify.com/pushengage-1';
	});
	/* --------  End handling pricing page to signup page redirection part --------*/
};

export default pricing;
